<template>
  <div>
    <div v-if="transaction">
      <div class="install-control">
        <a
          v-if="
            transaction &&
            transaction['api_result'] &&
            transaction['api_result']['act_pdf']
          "
          class="btn"
          target="_blank"
          :href="`https://newres.paymart.uz/${transaction['api_result']['act_pdf']}`"
          >{{ "donwload_act_template" | setText("Скачать АКТ-шаблон") }}</a
        >
        <button
          v-if="$store.state['user']['is_root'] && contract"
          @click="cancel"
          class="btn btn-danger"
        >
          {{ "cancel_order" | setText("Отменить заказ") }}
        </button>
      </div>
      <hr />
      <h5>{{ "upload_akt_pdf" | setText("Загрузить акт (PDF файл)") }}</h5>
      <zip-upload v-model="file" :title="'Выберите PDF'" @input="uploadAct" />
      <div v-if="transaction['act']">
        <a class="btn" target="_blank" :href="`${transaction['act']}`">{{
          "download_act" | setText("Скачать АКТ")
        }}</a>
        <br />
        <br />
      </div>
      <h5>
        {{
          "upload_photo_client_products"
            | setText("Загрузить фото клиента с товаром (PNG/JPG формат)")
        }}}
      </h5>
      <zip-upload
        v-model="photo"
        :title="'Выберите PNG/JPG изображение'"
        :titleKey="'choose_png_jpg'"
        @input="uploadPhoto"
      />

      <div v-if="transaction['client_product']">
        <a
          class="btn"
          target="_blank"
          :href="`${transaction['client_product']}`"
          >{{ "donwload_photo" | setText("Скачать фото") }}</a
        >
        <br />
        <br />
      </div>
    </div>
    <div v-else>
      <h4>
        {{
          "order_error"
            | setText(
              "ЗАКАЗ НЕ ЗАФИКСИРОВАН В СИСТЕМЕ КБ. СООБЩИТЕ АДМИНИСТРАЦИИ"
            )
        }}
      </h4>
    </div>
    <div v-if="transaction && transaction['api_result']">
      <div v-if="transaction['api_result']['paymart_client']">
        <ul>
          <li>
            {{ "order_number" | setText("Номер заказа") }}:
            {{ transaction["exchange_additional_id"] }}
          </li>
          <li>
            {{ "order_number" | setText("Номер заказа") }} (API):
            {{ transaction["exchange_id"] }}
          </li>
          <li>
            {{ "partner" | setText("Партнер") }}:
            {{ transaction["partner"]["name"] }}
          </li>
          <li>
            {{ "status" | setText("Статус") }}: {{ transaction["status"] }}
          </li>
          <li>
            {{ "customer" | setText("Заказчик") }}:
            {{ transaction["api_result"]["paymart_client"]["fio"] }}
          </li>
          <li>
            {{ "phone_contact" | setText("Контактный номер") }}:
            {{ transaction["api_result"]["paymart_client"]["phone"] }}
          </li>
          <li>
            {{ "price_total" | setText("Общая стоимость") }}:
            {{ transaction["api_result"]["paymart_client"]["total"] }}
          </li>
          <li>
            {{ "created" | setText("Создан") }}:
            {{ transaction["api_result"]["paymart_client"]["created_at"] }}
          </li>
        </ul>
      </div>
      <hr />
      <div v-if="transaction['api_result']['without_nds_product_price']">
        {{ "without_nds" | setText("БЕЗ НДС") }}:
        <ul>
          <li
            v-for="(schedule, key) in transaction['api_result'][
              'without_nds_product_price'
            ]"
            :key="key"
          >
            {{ schedule }} UZS
          </li>
        </ul>
      </div>
      <hr />
      <div v-if="transaction['api_result']['nds']">
        {{ "nds" | setText("НДС") }}:
        <ul>
          <li
            v-for="(schedule, key) in transaction['api_result']['nds']"
            :key="key"
          >
            {{ schedule }} UZS
          </li>
        </ul>
      </div>
      <hr />
      <div v-if="transaction['api_result']['payment_schedule']">
        Платежи:
        <ul>
          <li
            v-for="(schedule, key) in transaction['api_result'][
              'payment_schedule'
            ]"
            :key="key"
          >
            {{ schedule["payment_date"] }} - {{ schedule["payment_total"] }} UZS
          </li>
        </ul>
      </div>
      <hr />
      <div v-if="transaction['api_result']['cart']">
        <ul>
          <li
            v-for="(cart, key) in transaction['api_result']['cart']"
            :key="key"
          >
            {{ cart["name"] }} - {{ cart["price"] }} UZS x {{ cart["amount"] }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { logger } from "../../../plugins/functions";

export default {
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return {};
      },
    },
    contract: {
      default: null,
    },
    createTransaction: {
      default: function () {},
    },
    index: {
      default: 0,
    },
    buyer: {
      default: 0,
    },
  },
  name: "filter",
  async created() {},
  methods: {
    next() {
      this.$emit("next", -1);
    },
    async uploadAct() {
      this.$loading(true);

      logger(this.$http, {
        name: "Загрузка акта в #PAYMART",
        description: "Начало запроса",
        model_type: "order",
        model_id: this.order.id,
      });

      let bodyFormData = new FormData();
      bodyFormData.append("id", this.transaction["exchange_id"]);
      bodyFormData.append("act", this.file);
      this.$http({
        url: `${this.partner["endpoint_url"]}v1/contracts/upload/act`,
        method: "POST",
        data: bodyFormData,
        headers: {
          Authorization: `Bearer ${this.partner["api_secret_key"]}`,
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          if (response.data) {
            switch (response.data.status) {
              case "success":
                this.message = "Акт успешно загружен";

                this.createTransaction({
                  akt_uploaded: 1,
                  akt: this.file,
                });

                break;
              default:
                this.message = "Прикрепите АКТ для PAYMART";
                break;
            }

            this.$notify({
              title: "PAYMART",
              message: this.message,
              icon: "ti-save",
              horizontalAlign: "right",
              verticalAlign: "top",
            });

            logger(this.$http, {
              name: "Загрузка акта в #PAYMART",
              description: this.message,
              model_type: "order",
              model_id: this.order.id,
            });
          }

          this.$loading(false);
        })
        .catch((error) => {
          this.$loading(false);
          logger(this.$http, {
            name: "Загрузка акта в #PAYMART",
            description: "Ошибка системы #PAYMART",
            model_type: "order",
            model_id: this.order.id,
          });
          alert("Ошибка загрузки у партнера");
        })
        .finally(() => {});
    },
    async uploadPhoto() {
      this.$loading(true);

      logger(this.$http, {
        name: "Загрузка фото клиента с товаром в #PAYMART",
        description: "Начало запроса",
        model_type: "order",
        model_id: this.order.id,
      });

      let bodyFormData = new FormData();
      bodyFormData.append("id", this.transaction["exchange_additional_id"]);
      bodyFormData.append("client_photo", this.photo);
      this.$http({
        url: `${this.partner["endpoint_url"]}v1/contracts/upload-client-photo`,
        method: "POST",
        data: bodyFormData,
        headers: {
          Authorization: `Bearer ${this.partner["api_secret_key"]}`,
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          if (response.data) {
            switch (response.data.status) {
              case "success":
                this.message = "Фото успешно загружено";
                this.createTransaction({
                  client_product: this.photo,
                });
                break;
              default:
                this.message = "Прикрепите PNG или JPG формат файла";
                break;
            }

            this.$notify({
              title: "PAYMART",
              message: this.message,
              icon: "ti-save",
              horizontalAlign: "right",
              verticalAlign: "top",
            });

            logger(this.$http, {
              name: "Загрузка фото клиента с товаром в #PAYMART",
              description: this.message,
              model_type: "order",
              model_id: this.order.id,
            });
          }

          this.$loading(false);
        })
        .catch((error) => {
          logger(this.$http, {
            name: "Загрузка фото клиента с товаром в #PAYMART",
            description: "Ошибка системы #PAYMART",
            model_type: "order",
            model_id: this.order.id,
          });
          this.$loading(false);
          alert("Ошибка загрузки у партнера");
        })
        .finally(() => {});
    },
    cancel() {
      this.$loading(true);

      logger(this.$http, {
        name: "Отмена заказа в #PAYMART",
        description: "Начало запроса",
        model_type: "order",
        model_id: this.order.id,
      });

      this.$http
        .post(
          `${this.partner["endpoint_url"]}v1/buyers/credit/cancel`,
          {
            buyer_phone: this.order.client.phone,
            contract_id: this.contract,
          },
          {
            headers: {
              Authorization: `Bearer ${this.partner["api_secret_key"]}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (response.data) {
            switch (response.data.result.status) {
              case 1:
                this.message = "Успешно отменен";
                this.createTransaction({
                  status: -1,
                });
                this.$emit("next", -1);
                break;
              default:
                this.message = "Заказ не отменен";
                break;
            }
            this.$notify({
              title: "PAYMART",
              message: this.message,
              icon: "ti-save",
              horizontalAlign: "right",
              verticalAlign: "top",
            });
            logger(this.$http, {
              name: "Отмена заказа в #PAYMART",
              description: this.message,
              model_type: "order",
              model_id: this.order.id,
            });
          }
        })
        .catch((error) => {
          logger(this.$http, {
            name: "Отмена заказа в #PAYMART",
            description: "Ошибка системы #PAYMART",
            model_type: "order",
            model_id: this.order.id,
          });
          alert("Ошибка партнера");
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      message: "",
      file: "",
      photo: "",
    };
  },
};
</script>
<style lang="scss">
</style>
